import { render, staticRenderFns } from "./ContributeArtList.vue?vue&type=template&id=05a68141&scoped=true"
import script from "./ContributeArtList.vue?vue&type=script&lang=ts"
export * from "./ContributeArtList.vue?vue&type=script&lang=ts"
import style0 from "./ContributeArtList.vue?vue&type=style&index=0&id=05a68141&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a68141",
  null
  
)

export default component.exports